<template>
  <div id="pagination" class="flex flex-row items-center">
    <button data-testid="my-calendar.pagination.prev-page-btn" :disabled="curPage === 1" @click="$emit('page-change', curPage - 1)">
      <img src="@/assets/my-calendar/chevron_left_24dp.svg" class="mr-4" alt="chevron left" />
    </button>
    <el-pagination
      data-testid="my-calendar.pagination.pager"
      layout="pager"
      :total="totalNum"
      :current-page="curPage"
      :page-size="perPage"
      :pager-count="5"
      @current-change="page => $emit('page-change', page)"
    />
    <button data-testid="my-calendar.pagination.next-page-btn" :disabled="curPage === totalPage" @click="$emit('page-change', curPage + 1)">
      <img src="@/assets/my-calendar/chevron_right_24dp.svg" class="ml-4" alt="chevron right" />
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  totalNum: { type: Number, default: 0 },
  curPage: { type: Number, default: 1 },
  perPage: { type: Number, default: 10 }
})

const totalPage = computed(() => Math.ceil(props.totalNum / props.perPage))
</script>

<style scoped>

#pagination :deep(.el-pagination) {
  font-weight: normal;
}
#pagination :deep(.el-pager li) {
  min-width: 22px;
  margin: 0 4px;
}
#pagination :deep(.el-pager li.number) {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  height: 24px;
  width: 24px;
}
#pagination :deep(.el-pager li.is-active) {
  background-color: #004879;
  border-radius: 17px;
  color: #ffffff;
  /* padding: 4px 3px; */
}

  

.fixed-pagination .el-pager {
  width: 336px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>